// import React from "react";
// export const apiurl = "https://blackberrys-catalog-api-new.onrender.com";
// export const apiurl = "${apiurl}";
export const apiurl = "https://api-inficonnect.fixall.ai";
// export const apiurl = "https://catalog-pro-engine.onrender.com";
// export const apiurl = "http://localhost:5050";
// export const apiurl = "http://localhost:3000";